import { ReactElement } from 'react';
import StackView from '@components/StackView';
import { CronosEthereumTransferType } from '@types';
import Icon from '@components/Icon';
import Tooltip from '@components/Tooltip';

export interface CronosWrapPoolRadioButtonsProps {
  onChange(v: CronosEthereumTransferType): void;
  value: CronosEthereumTransferType;
}

function CronosWrapPoolRadioButtons({
  onChange,
  value,
}: CronosWrapPoolRadioButtonsProps): ReactElement {
  return (
    <StackView className="text-left" direction="vertical" spacing={1}>
      <div className="flex flex-row items-center">
        <div className="text-heading5 text-white">Transfer mode</div>
        <Tooltip
          className="ml-1"
          message={
            <div className="text-microLight">
              <b>Cronos Pool</b>: User pays 10% of a transaction fee dynamically
              calculated based on current ETH gas cost.
              <br />
              <br />
              <b>Cronos Warp</b>: User pays 100% of a transaction fee
              dynamically calculated based on current ETH gas cost.
            </div>
          }
        />
      </div>
      <div className="flex flex-row">
        <div>
          <input
            className="mr-1 h-3 w-3"
            checked={value === CronosEthereumTransferType.CronosPool}
            id="cronos-pool"
            data-testid="cronos-pool-radio"
            name="cro-eth-transfer-type"
            onChange={(e): void =>
              onChange(e.target.value as CronosEthereumTransferType)
            }
            type="radio"
            value={CronosEthereumTransferType.CronosPool}
          />
        </div>
        <div>
          <label
            className="text-white flex flex-row items-center"
            htmlFor="cronos-pool"
            data-testid="cronos-pool-label"
          >
            <Icon.Clock />
            <span className="ml-0.5">Cronos Pool</span>
          </label>
          <p className="text-white text-micro">
            ~5 mins up to 12 hours | batched transfer for unhurried transactions
          </p>
        </div>
      </div>
      <div className="flex flex-row">
        <div>
          <input
            className="mr-1 h-3 w-3"
            checked={value === CronosEthereumTransferType.CronosWarp}
            id="cronos-warp"
            data-testid="cronos-warp-radio"
            name="cro-eth-transfer-type"
            onChange={(e): void =>
              onChange(e.target.value as CronosEthereumTransferType)
            }
            type="radio"
            value={CronosEthereumTransferType.CronosWarp}
          />
        </div>
        <div>
          <label
            className="text-white flex flex-row items-center"
            htmlFor="cronos-warp"
            data-testid="cronos-warp-label"
          >
            <Icon.Instant />
            <span className="ml-0.5">Cronos Warp</span>
          </label>
          <p className="text-white text-micro">
            ~Few mins up to 1 hour | immediate transfer for rush transactions
          </p>
        </div>
      </div>
    </StackView>
  );
}

export default CronosWrapPoolRadioButtons;
